
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 42 45\" id=\"pause\" ><rect x=\"12.2\" y=\"12.38\" width=\"6.76\" height=\"19.62\" rx=\".53\"/><rect x=\"22.28\" y=\"12.38\" width=\"6.76\" height=\"19.62\" rx=\".53\"/></symbol>";
module.exports = sprite.add(image, "pause");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pause.svg
// module id = 305
// module chunks = 1